import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AppLocalStorage } from "../../../app-storage-manager/local-storage"

@Injectable({
    providedIn: 'root'
})

export class AuthGuardService implements CanActivate {
    constructor(private router: Router, private storeManager: AppLocalStorage) {}

    canActivate(): boolean | UrlTree {
        if (!this.storeManager.isStoredInSession('xs_access_token')) {
            return this.router.createUrlTree(['/auth']);
        }
        return true;
    }
}
